import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_operator_icon = _resolveComponent("operator-icon")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createBlock(_component_swiper, {
    autoplay: _ctx.autoplay,
    breakpoints: _ctx.breakpoints,
    modules: _ctx.modules,
    navigation: false,
    class: "operator-list"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.operators, (operator, index) => {
        return (_openBlock(), _createBlock(_component_swiper_slide, { key: index }, {
          default: _withCtx(() => [
            _createVNode(_component_operator_icon, { name: operator }, null, 8, ["name"])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }, 8, ["autoplay", "breakpoints", "modules"]))
}